

// REPO PATH:  src/front-end/code/app/notify/index.js
//
// REVERT-NOTE(unified-notify): NEW FILE — part of the notification
// unification branch. If reverting the unification, delete this folder and
// restore the commented-out originals at every "REVERT-NOTE(unified-notify)"
// marker across the app (grep for that token; see UNIFICATION-NOTES.md at
// the repo root for the full list).
//
// Toast notifications. Replaces two prior patterns:
//   1. native alert(...) calls
//   2. hand-rolled transient state: setMsg(...) + setTimeout(() => setMsg(''))
//
// Usage from anywhere (no hooks, no Redux):
//   import { notify } from '<path>/app/notify';
//   notify.success('upload successful');
//   notify.error('Send failed: ' + err.message);
//   notify.info('Queued 3 updates.');
//
// <Toasts/> must be mounted once (done in Splash.js) for these to render.
// Errors linger longer than successes by default. Click a toast to dismiss.

import React, { useEffect, useState } from 'react';
import styles from './notify.module.css';

let listeners = [];
let nextId = 1;

function push(kind, text, duration) {
    const toast = {
        id: nextId++,
        kind,
        text: String(text),
        duration: duration ?? (kind === 'error' ? 6000 : 3500),
    };
    if (listeners.length === 0) {
        // Toast host not mounted (pre-auth screens, tests) — don't lose the
        // message entirely.
        (kind === 'error' ? console.error : console.log)('[notify]', text);
        return;
    }
    listeners.forEach(l => l(toast));
}

export const notify = {
    success: (text, duration) => push('success', text, duration),
    error:   (text, duration) => push('error',   text, duration),
    info:    (text, duration) => push('info',    text, duration),
};

export const Toasts = () => {
    const [toasts, setToasts] = useState([]);

    useEffect(() => {
        const onToast = (t) => {
            setToasts(cur => [...cur, t]);
            setTimeout(() => {
                setToasts(cur => cur.filter(x => x.id !== t.id));
            }, t.duration);
        };
        listeners.push(onToast);
        return () => { listeners = listeners.filter(l => l !== onToast); };
    }, []);

    if (!toasts.length) return null;

    return (
        <div className={styles.toastStack} aria-live="polite">
            {toasts.map(t => (
                <div
                    key={t.id}
                    className={`${styles.toast} ${styles[t.kind] || ''}`}
                    onClick={() => setToasts(cur => cur.filter(x => x.id !== t.id))}
                    title="Dismiss"
                >
                    {t.text}
                </div>
            ))}
        </div>
    );
};